export default __webpack_public_path__ + "static/palm-atlantis-aaf9657068c923c6cc455a33c7b6ea97.webp";